import { render, staticRenderFns } from "./FCForceUpdate.vue?vue&type=template&id=3f5b7814&scoped=true&"
import script from "./FCForceUpdate.vue?vue&type=script&lang=ts&"
export * from "./FCForceUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b7814",
  null
  
)

export default component.exports